import { PaxCheckApplyTravelDocumentResult } from "api";
import PaxSession, { PaxSessionFromApi } from "models/session/pax-session";

interface SubmitPassportResponse {
  updatedPaxSession?: PaxSession;
  successfullyVerified: boolean;
}

export function ApplyPassportResponseFromApi(
  res: PaxCheckApplyTravelDocumentResult
): SubmitPassportResponse {
  return {
    successfullyVerified: res.successfullyVerified,
    updatedPaxSession: res.updatedPaxSession
      ? PaxSessionFromApi(res.updatedPaxSession)
      : undefined,
  };
}

export default SubmitPassportResponse;
